export default [
    {
      path: '/userManage/UserList',
      name: 'userList',
      component: () => import('@/views/userManage/UserList'),
      meta: { title: 'menu.userList', keepAlive: true, permission: ['table'] },
    },
    {
      path: '/userManage/CreateUser',
      name: 'createUser',
      component: () => import('@/views/userManage/CreateUser'),
      meta: { title: 'menu.createUser', keepAlive: true, permission: ['form'] },
    },
    {
      path: '/userManage/UserDetails',
      name: 'UserDetails',
      component: () => import('@/views/userManage/UserDetails'),
      meta: { title: 'menu.UserDetails', keepAlive: true, permission: ['form'] },
    },
  ]